(ns practitest.frontend.components2.dashboard.subs
  (:require [practitest.frontend.components2.dashboard.helpers :as helpers]
            [practitest.frontend.components2.issue-status :as issue-status]
            [practitest.frontend.components2.run-status :as run-status]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [re-frame.core :as r]))

(r/reg-sub
 ::item
 (fn [db [_ id]]
   (get-in db [:dashboard-items id])))

(r/reg-sub
 ::chart
 (fn [[_ id]]
   {:item (r/subscribe [::item id])})
 (fn [{:keys [item system-colors]} _]
   (when (seq item)
     (let [issue-colors  (update-vals issue-status/statuses-map :color)
           run-colors    (update-vals run-status/statuses-map :color)
           system-colors (:chart/status-colors item)
           legend-labels (or (:chart/legend-labels item) [])
           known-palette (helpers/palette item [system-colors issue-colors run-colors])
           ;; fills in any label missing a color from the sources above
           ds-fallback    (helpers/fill-missing-colors known-palette legend-labels)
           colors-palette (-> (merge known-palette ds-fallback)
                              (helpers/assign-colors legend-labels))]
       (-> item
           (assoc :chart/colors-palette colors-palette)
           p/transform-data)))))
